import React from 'react';

/**
 * Sk — bloc « squelette » avec shimmer (voir .skeleton dans index.css).
 * Skeleton de chargement > spinner : on montre la forme de la page, pas un sablier.
 */
export function Sk({ w = '100%', h = 12, r = 8, className = '', style = {} }) {
  return <div className={`skeleton ${className}`} style={{ width: w, height: h, borderRadius: r, ...style }} />;
}

/**
 * ListSkeleton — silhouette d'une page-liste (en-tête + bandeau KPI en filets +
 * lignes de table). À retourner pendant `loading` à la place du spinner.
 */
export default function ListSkeleton({ kpi = 4, rows = 6 }) {
  return (
    <div data-testid="list-skeleton" aria-busy="true">
      {/* En-tête */}
      <div className="flex items-end justify-between mb-8">
        <div>
          <Sk w={200} h={26} r={6} />
          <Sk w={130} h={13} r={5} className="mt-3" />
        </div>
        <Sk w={150} h={38} r={8} />
      </div>

      {/* Bandeau KPI en filets */}
      {kpi > 0 && (
        <div className="grid grid-cols-2 xl:grid-cols-4 mb-8" style={{ borderTop: '1px solid var(--border-soft)', borderBottom: '1px solid var(--border-color)' }}>
          {Array.from({ length: kpi }).map((_, i) => (
            <div key={i} className="py-6 pr-5 pl-5 first:pl-0" style={{ borderRight: i < kpi - 1 ? '1px solid var(--border-color)' : 'none' }}>
              <Sk w={90} h={10} r={4} />
              <Sk w={64} h={30} r={6} className="mt-4" />
              <Sk w={104} h={10} r={4} className="mt-4" />
            </div>
          ))}
        </div>
      )}

      {/* Table */}
      <div className="rounded-[12px] overflow-hidden" style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 px-4 py-3.5" style={{ borderBottom: '1px solid var(--bg-tertiary)' }}>
            <Sk w={34} h={34} r={999} />
            <Sk w={`${28 + ((i * 13) % 22)}%`} h={12} r={5} />
            <Sk w={`${14 + ((i * 7) % 14)}%`} h={12} r={5} />
            <div className="flex-1" />
            <Sk w={70} h={20} r={6} />
          </div>
        ))}
      </div>
    </div>
  );
}
